module.exports = __webpack_public_path__ + "img/Exit_Icon_Blue.862e780b.svg";